<template>
  <div>{{ `${day}天${hr}:${min}:${sec}` }}</div>
</template>

<script>
export default {
  data () {
    return {
      timeId: null,
      day: 0,
      hr: 0,
      min: 0,
      sec: 0
    }
  },
  props: {
    endTime: {
      type: Date,
      required: true
    }
  },
  mounted () {
    this.countdown()
  },
  computed: {},
  methods: {
    async countdown () {
      const end = Date.parse(new Date(this.endTime))
      const now = Date.parse(new Date())
      const msec = end - now
      let day = parseInt(msec / 1000 / 60 / 60 / 24)
      let hr = parseInt(msec / 1000 / 60 / 60 % 24)
      let min = parseInt(msec / 1000 / 60 % 60)
      let sec = parseInt(msec / 1000 % 60)
      this.day = day
      this.hr = hr > 9 ? hr : '0' + hr
      this.min = min > 9 ? min : '0' + min
      this.sec = sec > 9 ? sec : '0' + sec
      await this.$tkHelper.sleep(1000)
      this.countdown()
    }
  }
}
</script>

<style scoped lang="scss">

</style>
